import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { ChevronRight, Trash2 } from "lucide-react";

export default function CandidateSaved() {
  const [items, setItems] = useState([]);
  const load = async () => {
    const { data } = await api.get("/jobs/saved/list");
    setItems(data.items || []);
  };
  useEffect(() => { load(); }, []);

  const unsave = async (id) => {
    await api.delete(`/jobs/${id}/save`);
    toast.success("Removed");
    load();
  };

  return (
    <div>
      <div className="mb-6">
        <div className="eyebrow mb-2">Candidate</div>
        <h1 className="font-display text-3xl font-bold text-navy">Saved Jobs</h1>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {items.map(j => (
          <div key={j.id} className="border border-slate-200 rounded-xl p-5 bg-white flex justify-between items-start">
            <div>
              <div className="text-xs uppercase tracking-widest text-slate-500">{j.industry}</div>
              <div className="font-display text-lg text-navy font-semibold">{j.title}</div>
              <div className="text-sm text-slate-600">{j.employer_name} • {j.city}</div>
              <Link to={`/jobs/${j.id}`} className="text-sm text-navy font-medium mt-3 inline-flex items-center gap-1">View <ChevronRight className="w-4 h-4" /></Link>
            </div>
            <button onClick={() => unsave(j.id)} className="text-slate-400 hover:text-red-500"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
        {items.length === 0 && <div className="text-slate-500">No saved jobs yet.</div>}
      </div>
    </div>
  );
}
